import { authSlice } from "../../services/stores/auth/slice";
export const { logout } = authSlice.actions;

export default function Blank() {
  return (
    <h1>Nothing here...</h1> 
  );
}
